import { useIonViewWillEnter } from '@ionic/react';
import React, { useCallback, useEffect, useRef } from 'react';
import { Device } from '@capacitor/device';
import { BASE_URL } from '../utils/constant';


interface ContainerProps {
  pageIndex: number;
  dockIndex: number;
}

/**
This component is only used to send data to the server for metrics pourposes
*/
const PageEventHandler: React.FC<ContainerProps> = ({pageIndex, dockIndex}) => {
  const lastSentKey = useRef<string | null>(null);

  function getOrCreateFallbackId(): string
  {
    const key = 'po_app_fallback_uuid';
    const fromStorage = window.localStorage.getItem(key);
    if (fromStorage && fromStorage.trim().length > 0)
    {
      return fromStorage;
    }

    const generated = typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function'
      ? `web-${crypto.randomUUID()}`
      : `web-${Date.now()}-${Math.random().toString(36).slice(2)}`;
    window.localStorage.setItem(key, generated);
    return generated;
  }

  // send post req to save data
  function sendMessage(deviceId: string)
  {
    const postData = {
      pageIndex: pageIndex,
      dockIndex: dockIndex,
      userAgent: window.navigator.userAgent,
      uuid: deviceId,
      h: "gkzLoFk0MN58TGqCJj",
      act: 6
    }

    const url = `${BASE_URL}/poServer.php`;
    fetch(url, {
        method: 'post',
        mode: 'cors', // this has to be 'cors'
        body: JSON.stringify(postData),
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        }})
      .then((response) => {
        if (!response.ok)
        {
          console.warn('PageEventHandler: page view not accepted by server', response.status);
        }
      })
      .catch(error => {
        console.warn('PageEventHandler: error while sending page view', error);
      });
  }

  const sendPageView = useCallback(async (force = false) => {
    if (pageIndex == null)
    {
      return;
    }

    // Dock detail pages must wait for a real dock id (loaded async).
    if (pageIndex === 3 && (!dockIndex || dockIndex === 0))
    {
      return;
    }

    const sendKey = `${pageIndex}:${dockIndex}`;
    if (!force && lastSentKey.current === sendKey)
    {
      return;
    }
    lastSentKey.current = sendKey;

    let resolvedDeviceId = getOrCreateFallbackId();
    try
    {
      // Capacitor 6+ returns `identifier` (not `uuid`).
      const devId = await Device.getId();
      if (devId && typeof devId.identifier === 'string' && devId.identifier.trim().length > 0)
      {
        resolvedDeviceId = devId.identifier;
      }
    }
    catch (error: any)
    {
      // Keep fallback id and continue sending usage data.
    }

    sendMessage(resolvedDeviceId);
  }, [pageIndex, dockIndex]);

  useIonViewWillEnter(() => {
    // Allow a fresh send each time the page is opened.
    lastSentKey.current = null;
    sendPageView(true);
  });

  // When dock id arrives after view enter (Dock.tsx loads async).
  useEffect(() => {
    if (pageIndex === 3 && dockIndex > 0)
    {
      sendPageView();
    }
  }, [pageIndex, dockIndex, sendPageView]);

  return (
    <></>
  );
};

export default PageEventHandler;
